__turbopack_context__.v({
  "card": "TransportSection-module__cXZPLW__card",
  "descriptionRow": "TransportSection-module__cXZPLW__descriptionRow",
  "subtitle": "TransportSection-module__cXZPLW__subtitle",
  "title": "TransportSection-module__cXZPLW__title",
});
